"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MembershipTypeStore = /*#__PURE__*/function (_RootStore) {
  function MembershipTypeStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, MembershipTypeStore);
    _this = _callSuper(this, MembershipTypeStore);
    _this.config = {
      model: _models.MembershipType,
      GET: {
        index: '/membership_types',
        show: '/membership_types/:membershipTypeId',
        waitlistStatuses: '/membership_waitlists'
      },
      PUT: {
        update: '/membership_types/:membershipTypeId'
      },
      POST: {
        create: '/membership_types',
        joinWaitlist: '/membership_waitlists/:membershipTypeId/join'
      },
      DELETE: {
        destroy: '/membership_types/:membershipTypeId',
        leaveWaitlist: '/membership_waitlists/:membershipTypeId/leave'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(MembershipTypeStore, _RootStore);
  return (0, _createClass2["default"])(MembershipTypeStore, [{
    key: "getWaitlistStatusesPromise",
    value: function getWaitlistStatusesPromise() {
      return this.apiPromise({}, 'GET', 'waitlistStatuses');
    }
  }, {
    key: "joinWaitlistPromise",
    value: function joinWaitlistPromise(membershipTypeId) {
      return this.apiPromise({
        ids: {
          membershipTypeId: membershipTypeId
        }
      }, 'POST', 'joinWaitlist');
    }
  }, {
    key: "leaveWaitlistPromise",
    value: function leaveWaitlistPromise(membershipTypeId) {
      return this.apiPromise({
        ids: {
          membershipTypeId: membershipTypeId
        }
      }, 'DELETE', 'leaveWaitlist');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new MembershipTypeStore();